import React, { FC, useCallback } from 'react';
import { useDispatchRequest } from '@redux-requests/react';
import { Link, useHistory } from 'react-router-dom';
import { FORM_ERROR } from 'final-form';
import { Field, Form } from 'react-final-form';
import { TextInputWrapper } from 'components/forms';
import { Button } from 'components/ui';
import routesByName from 'constants/routes';
import FormError from '../FormError/FormError';
import { loginAndGetAccount } from '../store/actions';
import { signInFormFields } from './constants';
import { t } from 'utils';
import styles from './SignInComponent.module.scss';

const SignInComponent: FC = () => {
  const dispatchRequest = useDispatchRequest();
  const history = useHistory();

  const handleSubmit = useCallback(
    async (formValues: any) => {
      const { data, error } = await dispatchRequest(loginAndGetAccount(formValues) as any);

      if (error) {
        const isBlockedAccount = error.data.errors.find(
          (i: any) => i.extensions?.code === 'AccountDisabled'
        );
        if (isBlockedAccount) return { [FORM_ERROR]: 'error.accountBlocked' };
        return { [FORM_ERROR]: 'errors.loginError' };
      }

      if (data) {
        history.push(routesByName.apps.index);
      }
    },
    [dispatchRequest, history]
  );

  return (
    <Form
      onSubmit={handleSubmit}
      // validate={validateForm}
      render={({ handleSubmit, submitError, submitting, pristine }) => (
        <form className={styles.root} onSubmit={handleSubmit}>
          <Field
            className='mb-2'
            label='global.email'
            placeholder='global.email.placeholder'
            name={signInFormFields.email}
            type='email'
            component={TextInputWrapper}
          />
          <Field
            className='mb-5'
            label='global.password'
            placeholder='global.password.placeholder'
            name={signInFormFields.password}
            type='password'
            component={TextInputWrapper}
          />
          {submitError && <FormError text={t(submitError)} />}
          <div className={styles.formRow}>
            <Button disabled={submitting || pristine} inline>
              {t('login')}
            </Button>
            <Link className={styles.forgotLink} to={routesByName.auth.forgotten}>
              {t('forgot.your.password')}?
            </Link>
          </div>
        </form>
      )}
    />
  );
};

export default SignInComponent;
